import { createSelector } from "reselect"
import { get } from "lodash"

const getRawErrorMessage = state => get(state, "modules.setPassword.error")

export const getToken = (_, props) => get(props, "token")
export const getName = (_, props) => get(props, "name")
export const getEmail = (_, props) => get(props, "email")

export const getError = createSelector(
  [getRawErrorMessage, getToken],
  (errorMessage, token) => {
    if (!errorMessage && token) {
      return null
    }
    if (!token) {
      return { message: "Token has expired", nonRemovable: true }
    }

    return { message: errorMessage }
  })
